<template>
  <div class="v-date-picker">
    <el-date-picker
      :ref="refTime"
      v-model="calendar"
      type="daterange"
      :picker-options="pickerOptions"
      range-separator="-"
      :start-placeholder="$t('common.startDate')"
      :end-placeholder="$t('common.endDate')"
      format="yyyy-MM-dd"
      :clearable="clearable"
      :value-format="formatType"
      @change="dateRangeChange"
    />
  </div>
</template>

<script>
export default {
  name: 'v-time',
  props: {
    refTime: {
      type: String,
      default: 'time',
    },
    pickerOptions: {
      // 时间选择范围
      type: Object,
      default: () => {},
    },
    formatType: {
      // 判断返回值是日期格式还是时间戳，timestamp：时间戳，日期格式：yyyy-MM-dd，默认是日期格式
      type: String,
      default: 'yyyy-MM-dd',
    },
    timeArr: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      calendar: null,
    };
  },
  watch: {
    timeArr(val) {
      this.calendar = val;
    },
  },
  created() {
    this.calendar = this.timeArr;
  },
  methods: {
    dateRangeChange(dateArr) {
      dateArr
        ? this.$emit('date-change', this.refTime, dateArr[0], dateArr[1], dateArr)
        : this.$emit('date-change', this.refTime);
    },
  },
};
</script>

<style lang="scss">
.v-date-picker {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>
